export default __webpack_public_path__ + "static/media/preflop-equity-handvsrange_0021_thumb.c638aa03.jpg";